import React from "react";

type Props = {
  width: number;
  height: number;
};

export const IconCalendarSVG: React.FC<Props> = (props) => {
  const { width, height } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="currentColor"
      viewBox={`0 0 54 54`}
    >
      <g
        id="Buttons_-_Symbol"
        data-name="Buttons - Symbol"
        transform="translate(0.531)"
      >
        <rect
          id="Frame"
          width="54"
          height="54"
          transform="translate(-0.531)"
          fill="rgba(0,0,0,0)"
          opacity="0"
        />
        <g
          id="グループ_1481"
          data-name="グループ 1481"
          transform="translate(10.469 9)"
        >
          <g id="グループ_1480" data-name="グループ 1480">
            <path
              id="パス_9873"
              data-name="パス 9873"
              d="M19.515,8.288l-1.891-.275L16.779,6.3c-.293-.592-.766-.592-1.058,0l-.846,1.713-1.891.275c-.653.1-.8.546-.326,1.007l1.368,1.332L13.7,12.511c-.112.65.272.929.856.621l1.691-.888,1.69.888c.585.308.968.029.856-.621l-.322-1.884L19.841,9.3c.473-.461.327-.912-.326-1.007"
            />
            <path
              id="パス_9874"
              data-name="パス 9874"
              d="M31.532,2.759H25.873V0H6.627V2.759H.968A.968.968,0,0,0,0,3.727V8.915a5.378,5.378,0,0,0,5.378,5.378H7.322a12.327,12.327,0,0,0,3.48,4.473l.424.342a5.462,5.462,0,0,1,2.024,4.244v2.235h6V23.036a4.8,4.8,0,0,1,1.779-3.729l.669-.541a12.327,12.327,0,0,0,3.48-4.473h1.944A5.377,5.377,0,0,0,32.5,8.916V3.727a.968.968,0,0,0-.968-.968M5.378,11.793A2.877,2.877,0,0,1,2.5,8.916V5.259H6.627v5.967c0,.19.03.378.047.567Zm14.161,2.975a6.186,6.186,0,0,1-8.5-8.5,4.77,4.77,0,0,1,1.925-1.925,6.186,6.186,0,0,1,8.5,8.5,4.77,4.77,0,0,1-1.924,1.926M30,8.915a2.878,2.878,0,0,1-2.878,2.878h-1.3c.017-.189.047-.377.047-.567V5.259H30ZM26.25,34.087h-2V30.869a2.781,2.781,0,0,0-2.782-2.782H11.032A2.781,2.781,0,0,0,8.25,30.869v3.218h-2v3h20Zm-5.555-1H11.806v-2h8.889Z"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};
